export {};

const prevArrow = NLMK.generateSlickArrow('left', 'prev');
const nextArrow = NLMK.generateSlickArrow('right', 'next');

NLMK.initTitledSlide = init;
$(window).on('NLMK.simpleSlider', init);

$(init);

function init() {
    $('.simple-slider').each(eachBlock);
}

function eachBlock(blockIndex, Block) {
    const $block = $(Block);
    const $slider = $block.find('.simple-slider__list');

    const $controls = $block.find('.simple-slider__controls');

    const $currentIndex = $controls.find('.simple-slider__current-index');
    const $totalSlides = $controls.find('.simple-slider__total-slides');
    const infinite = $slider.data('infinite');
    const noPointer = 'no-pointer';

    const $arrowNext = $(nextArrow);
    const $arrowPrev = $(prevArrow);

    const $arrows = $(document.createDocumentFragment());

    $arrows.append($arrowPrev.clone()).append($arrowNext);

    $controls.append($arrows);

    const options = {
        arrows: false,
        dots: false,
        infinite: typeof infinite !== 'undefined' && !!infinite,
        mobileFirst: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    $slider
        .on('init', onSlickInit)
        .on('afterChange', afterChange)
        .slick(options);

    function afterChange(ev, Api, currentSlide) {
        const slideNum = currentSlide + 1;
        $currentIndex.text(slideNum);

        if (!Api.options.infinite && Api.$slides.length > 1) {
            const $prevBtn = $controls.find('.slick-prev');
            const $nextBtn = $controls.find('.slick-next');
            const $prevArrow = $prevBtn.find('.svg-symbol');
            const $nextArrow = $nextBtn.find('.svg-symbol');

            if (slideNum === 1) {
                hideArrow($prevBtn, $prevArrow, 300);
                showArrow($nextBtn, $nextArrow);
            } else if (slideNum === Api.$slides.length) {
                hideArrow($nextBtn, $nextArrow, 300);
                showArrow($prevBtn, $prevArrow);
            } else {
                showArrow($prevBtn, $prevArrow);
                showArrow($nextBtn, $nextArrow);
            }
        }
    }

    function onSlickInit(ev, Api) {
        $block
            .on('click', '.slick-next', (evt) => {
                Api.next();

                evt.preventDefault();
            })
            .on('click', '.slick-prev', (evt) => {
                Api.prev();

                evt.preventDefault();
            });

        $currentIndex.text(Api.currentSlide + 1);
        $totalSlides.text(Api.$slides.length);

        if (!Api.options.infinite) {
            hideArrow($controls.find('.slick-prev'), $controls.find('.slick-prev .svg-symbol'));

            if (Api.$slides.length === 1) {
                hideArrow($controls.find('.slick-next'), $controls.find('.slick-next .svg-symbol'));
            }
        }
    }

    function hideArrow($btn, $arrow, timeout = 0) {
        if ($arrow.is(':visible')) {
            $arrow.fadeOut(timeout);

            if (!$btn.hasClass(noPointer)) {
                $btn.addClass(noPointer);
            }
        }
    }

    function showArrow($btn, $arrow, timeout = 300) {
        if ($arrow.is(':hidden')) {
            $arrow.fadeIn(timeout);

            if ($btn.hasClass(noPointer)) {
                $btn.removeClass(noPointer);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/simple.js